// extracted by mini-css-extract-plugin
export default {"imprint_sections":"style_imprint_sections__-E2x9","headline_1":"style_headline_1__1zCBY","headline_2":"style_headline_2__Ns8Sx","content_block":"style_content_block__d9eSF"};